export const i18nRu = {
  label: {
    metrics: 'ÐÐµÑÑÐ¸ÐºÐ¸',
    search: 'ÐÐ¾Ð¸ÑÐº',
    dark: 'Ð¢ÐµÐ¼Ð½Ð°Ñ',
    light: 'Ð¡Ð²ÐµÑÐ»Ð°Ñ',
  },
  action: {
    reload: 'ÐÐ±Ð½Ð¾Ð²Ð¸ÑÑ',
    hide_sidebar: 'Ð¡ÐºÑÑÑÑ Ð¿Ð°Ð½ÐµÐ»Ñ',
    ok: 'ÐÐº',
    cancel: 'ÐÑÐ¼ÐµÐ½Ð°',
    select_all: 'ÐÑÐ±ÑÐ°ÑÑ Ð²ÑÐµ'
  }

};
